import { render, staticRenderFns } from "./MeusClientes.vue?vue&type=template&id=431373d4&"
import script from "./MeusClientes.vue?vue&type=script&lang=js&"
export * from "./MeusClientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports